import React from 'react';
import Card3D from './Card3D';
import * as Icons from 'lucide-react';

interface ServiceFeatureCardProps {
  iconName: string;
  title: string;
  description: string;
  color: string;
}

const ServiceFeatureCard: React.FC<ServiceFeatureCardProps> = ({
  iconName,
  title,
  description,
  color
}) => {
  // Dynamically get the icon component
  const IconComponent = Icons[iconName as keyof typeof Icons];

  return (
    <Card3D>
      <div className="bg-white p-6 rounded-xl h-full">
        <div 
          className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
          style={{
            backgroundColor: `${color}15`,
            color: color
          }}
        >
          {IconComponent && <IconComponent className="w-6 h-6" />}
        </div>
        <h3 className="text-lg font-bold mb-2" style={{ color }}>
          {title}
        </h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </Card3D>
  );
};

export default ServiceFeatureCard;